import { render, staticRenderFns } from "./SpotifyPlayer.vue?vue&type=template&id=389131f6&scoped=true&"
import script from "./SpotifyPlayer.vue?vue&type=script&lang=js&"
export * from "./SpotifyPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SpotifyPlayer.vue?vue&type=style&index=0&id=389131f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389131f6",
  null
  
)

export default component.exports